import { getProjectConfigurationParameters } from './get-project-configuration-parameters';
import { configurationTypes } from '../../../const';
import { LaminateInputs, TCreateConfigurationBody } from '../../../types';

export const getCreateConfigurationBody = (
  inputsData: LaminateInputs,
  isKazakhstan: boolean,
  customerId: string,
  isAuthorized: boolean
): TCreateConfigurationBody => {
  const projectConfigurationParameters = getProjectConfigurationParameters(inputsData);

  return {
    configurationType: configurationTypes.FLOOR_COVERING,
    buCode: isKazakhstan ? 40 : 9,
    currency: isKazakhstan ? 'KZT' : 'RUB',
    projectConfigurationParameters,
    customerId,
    isAuthorized,
  };
};
